import {Injector} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {
    WidgetImplementation,
    WidgetImplementationEvent,
    WidgetImplementationEventFlags
} from '../../components/layout/widget/widget-implementation';
import {setWidgetSettings, updateWidgetSettings} from '../components/common-widget.implementation';
import {DexDynWidgetSettings} from './settings/dex-dyn-widget-settings';
import {DexDynWidgetSettingsService} from './settings/dex-dyn-widget-settings.service';

export class DexDynWidgetImplementation implements WidgetImplementation {

    public settings: DexDynWidgetSettings;

    public settingsService: DexDynWidgetSettingsService = this.injector.get(DexDynWidgetSettingsService);

    public ready$ = new BehaviorSubject<boolean>(false);

    public event$ = new Subject<WidgetImplementationEvent>();

    constructor(
        private injector: Injector
    ) {}

    public setSettings(
        settings?: DexDynWidgetSettings,
        flags?: WidgetImplementationEventFlags
    ): Observable<DexDynWidgetSettings> {
        return setWidgetSettings(this, settings, flags);
    }

    public updateSettings(
        updates?: Partial<DexDynWidgetSettings>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<DexDynWidgetSettings>> {
        return updateWidgetSettings(this, updates, flags);
    }

}
